import {View} from 'MWC';
import tpl from './templates/interactive.jsx';
import Model from './model/model.m';
import {apiback} from '../../../../../../config';

const vygoda = 'credit_vygoda';

export default class extends View {
    template = tpl;

    constructor(props) {
        super(props);

        this.state = {
            selectedType: vygoda,
            model: {}
        };

        return this;
    }

    componentWillMount() {
        fetch(apiback('INSTALLMENT_VYGODA'))
            .then(response => response.json())
            .then(json =>
                this.setState({
                    model: new Model(json.data.credit_vygoda)
                })
            );
        // .catch(x => console.log("error:", x)); todo добавить обработчик
    }

    static displayName = 'VygodaInstallmentCalc';
}
